import { InjectionToken } from '@angular/core';
import { GridType } from '@data-access/grid-views';

import { OrganizationSiteGrid } from '../types';
import environment from '@environments/environment';
import { DEFAULT_BASE_GRID_PROPS } from './base-grid-props.constant';
/* eslint-disable @typescript-eslint/naming-convention */

export const siteListInitialState: OrganizationSiteGrid = {
  data: [],
  currentUrl: '',
  gridType: 'site' as GridType,
  views: [],
  ...DEFAULT_BASE_GRID_PROPS,
};

export const ORGANIZATION_SITE_GRID_STATE =
  new InjectionToken<OrganizationSiteGrid>('Organization Site grid state', {
    factory: () => ({ ...siteListInitialState }),
  });

/** @NOTE: This URL is used in the contact details page to fetch the contact details and update the contact details. It is not used in any other place. */
export const CONTACT_URL = `${environment.irisApi}/auth/user`;
